import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getItem, removeItem } from "../../../helpers/data_management";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import {
  updateExitDialog,
  updateSignUpProfileDialog,
} from "../../../redux/actions/dialog_action";
import {
  ButtonStyled,
  CloseButton,
  CloseIcon,
  DialogContainer,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "./styles";

export default function SharedExitDialog(props) {
  const router = useRouter();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showExitDialog = useSelector((state) => state.dialog?.showExitDialog);

  const originUrl = getItem("apply_origin");
  const getBulkJobApply = getItem("bulkApplyFromSimilarJob");
  const fromOnboarding = sessionStorage.getItem("triggerSignUpProfileDialog");

  function handleClose(action) {
    dispatch(updateExitDialog(false));
    sendTrackingEvent({
      event: "CE_signup_easy_apply_back_click",
      colour: "-",
      cta: action,
    });
  }

  function handleExit() {
    // Close exit confirmation dialog if triggered from sign up profile dialog

    // Remove this local storage if visitor exits from bulk job apply
    dispatch(updateExitDialog(false));
    if (fromOnboarding) {
      dispatch(updateSignUpProfileDialog(false));
      sendTrackingEvent({
        event: "CE_onboarding_skip_click",
        origin: "onboarding",
      });
      sessionStorage.removeItem("triggerSignUpProfileDialog");
      router.push("/jobs");
      return;
    }

    if (getBulkJobApply) {
      sendTrackingEvent({
        event: "CE_view_similar_jobs_exit_click",
        colour: "red",
        cta: "Exit",
      });
      removeItem("bulkApplyFromSimilarJob");
    } else {
      sendTrackingEvent({
        event: "CE_signup_easy_apply_exit_click",
        colour: "red",
        cta: "Exit",
      });
    }

    if (originUrl) {
      removeItem("apply_origin");
      router.push(originUrl);
    } else {
      router.back();
    }
  }

  useEffect(() => {
    if (!router.pathname.startsWith("/apply")) {
      return;
    }

    let isLeaving = false;

    const handleBeforeUnload = (event) => {
      if (getItem("scraped_job_id")) {
        removeItem("scraped_job_id");
        return;
      }
      event.preventDefault();
      isLeaving = true;
      setTimeout(() => {
        if (isLeaving) {
          sendTrackingEvent({
            event: "CE_signup_easy_apply_back_click",
            colour: "-",
            cta: "Back",
          });
          isLeaving = false;
        }
      }, 1000);
      return event.returnValue;
    };

    const handlePopState = (event) => {
      event.preventDefault();
      history.pushState(null, "", window.location.href);
      dispatch(updateExitDialog(true));
    };

    const handlePageHide = () => {
      if (isLeaving) {
        sendTrackingEvent({
          event: "CE_signup_easy_apply_exit_click",
          colour: "red",
          cta: "Exit",
        });
        isLeaving = false;
      }
    };

    history.pushState(null, "", window.location.href);

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);
    window.removeEventListener("pagehide", handlePageHide);
  }, [router, dispatch]);

  return (
    <DialogContainer open={showExitDialog} data-testid="shared-exit-dialog" onClose={() => handleClose("X")}>
      <DialogHeader>
        {t("exit_dialog.title")}
        <CloseButton onClick={() => handleClose("X")} data-testid="shared-exit-close-btn">
          <CloseIcon />
        </CloseButton>
      </DialogHeader>
      <DialogContent>
        {t("exit_dialog.body")}
      </DialogContent>
      <DialogFooter>
        <ButtonStyled onClick={() => handleClose("Back")} data-testid="shared-exit-back-btn">
          {t("exit_dialog.back")}
        </ButtonStyled>
        <ButtonStyled variant="filled" onClick={handleExit} data-testid="shared-exit-confirm-btn">
          {t("exit_dialog.exit")}
        </ButtonStyled>
      </DialogFooter>
    </DialogContainer>
  );
}
